<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2055.19 2185.29" v-if='kirby.site.strings'>
    <path id="Curve" d="M13.73,2198.17V62.88a50,50,0,0,1,50-50H2068.91"/>
    <text :x="scroll * 1000" width="500" >
      <textPath xlink:href="#Curve"alignment-baseline="top">
        <tspan v-for="i in 7"  :key="i" v-once>
          helsinki darkroom festival 2022 FINNISH DARKROOM ASSOCIATION {{formattedDate(kirby.site.strings.startdate, 'd.m')}}-{{formattedDate(kirby.site.strings.enddate, 'd.m.yyyy')}} 
        </tspan>
      </textPath>
    </text>
  </svg>
</template>

<style scoped>

  svg {
    stroke: transparent;
    fill: transparent;
    font-size: 1rem;
    text-transform: uppercase;
    width: var(--curvetextwidth);
    pointer-events: none;
    z-index: 4;
    position: relative;
  }

  text {
    fill: var(--gray);
    transform: translate(0.25rem, 0.25rem);
  }

</style>


<script>
import mixins from '.././mixins.js';

export default {
  mixins: [mixins], //kirby(), urltopath(), etc
  props: ['scroll'],
}
</script>
